import { render, staticRenderFns } from "./InsideDrawer.vue?vue&type=template&id=badbfa82&scoped=true"
import script from "./InsideDrawer.vue?vue&type=script&lang=js"
export * from "./InsideDrawer.vue?vue&type=script&lang=js"
import style0 from "./InsideDrawer.vue?vue&type=style&index=0&id=badbfa82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badbfa82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('badbfa82')) {
      api.createRecord('badbfa82', component.options)
    } else {
      api.reload('badbfa82', component.options)
    }
    module.hot.accept("./InsideDrawer.vue?vue&type=template&id=badbfa82&scoped=true", function () {
      api.rerender('badbfa82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/logistics/company/csgAdmin/rateNew/components/InsideDrawer.vue"
export default component.exports